import { Select, SelectItem } from "@heroui/react";
import { useEffect, useState } from "react";
import InputSkeleton from "shared/skeletons/input.skeleton";

interface EditableSelectProps {
  editMode: boolean;
  value: string | boolean;
  options: { value: string | boolean; label: string }[];
  onChange: (value: string) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  label?: string;
  children?: React.ReactNode;
}

export const EditableSelectComponent: React.FC<EditableSelectProps> = ({
  editMode,
  value,
  options,
  onChange,
  isDisabled = false,
  isLoading = false,
  label,
  children,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    console.log(label);
    console.log(options);
    console.log(value);
    setSelectedValue(value);
  }, [value]);

  const handleSelectChange = (e: any) => {
    const newValue = e.target.value;
    setSelectedValue(newValue);
    onChange(newValue);
  };

  const getLabelForValue = (value: any) => {
    const option = options.find(opt => opt.value === value);
    return option ? option.label : "";  // Return an empty string if no match is found
  };

  if (isLoading) return <InputSkeleton />;
  if (editMode) {
    return (
      <Select
        label={label}
        isDisabled={isDisabled}
        selectedKeys={[value && (value.toString() as any)]}
        onChange={handleSelectChange}
        classNames={{
          label: "text-neutral-primary",
          value: "text-neutral-primary",
          trigger:
            "rounded-sm bg-white shadow-form-element! data-[hover=true]:bg-white group-data-[focus=true]:bg-white data-[hover=true]:shadow-form-element-hv! group-data-[focus=true]:shadow-form-element-fc!",
        }}
      >
        {options &&
          options.map((option) => (
            <SelectItem key={option.value as any}>
              {option.label}
            </SelectItem>
          ))}
      </Select>
    );
  }
  if (children) return <>{children}</>;
  const selectedOption =
    options && options.find((option) => option.value === selectedValue);
  return (
    <p className="font-medium">
      {selectedOption?.label || getLabelForValue(selectedValue) || selectedValue || "Niet ingevuld"}
    </p>
  );
};
